<template>
    <div v-if="currentUser">
      <div class="profile-container" v-if="currentUser.role_id === 4">
        <h2>Wybierz zakładkę</h2>
      </div>
    </div>
    <div v-else>
      <h2>Błąd wczytywania. Spróbuj ponownie</h2>
    </div>
  </template>
  
  <script>
  import { useMeta } from 'vue-meta';
  import {useAuthStore} from "@/stores/auth";
  export default{
    name:'EmployeeProfile',
    setup () {
      useMeta({title: 'profil pracownika'})
    
    return {
        authStore: useAuthStore(),
    }
  },
    data(){
      return{
  
      }
    },
    props:{
  
    },
    computed: {
      currentUser () {
        return this.authStore.user
      }
    },
    methods:{
    },  
    mounted(){
      if(!this.currentUser){
        this.$router.push('/login')
      }else if(this.currentUser.role_id !== 4){
        this.$router.push('/login')
      }else if(this.currentUser){
        this.$router.push('/dla-biznesu/employee-profile/user-data')
      }
    }
  }
  </script>
  
  <style scoped lang='scss'>
  
  </style>